import React, { useEffect, useState } from 'react';
import { useAuth } from '../App';
import Layout from '../components/Layout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { toast } from 'sonner';

export default function MyExchangeInbox() {
  const { axiosInstance, user } = useAuth();
  const [exchanges, setExchanges] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchInbox = async () => {
    try {
      const res = await axiosInstance.get('/exchanges/my-inbox');
      setExchanges(res.data);
    } catch (err) {
      toast.error("Erreur chargement inbox");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (user) fetchInbox();
  }, [user]);

  const accept = async (id) => {
    try {
      await axiosInstance.post(`/exchanges/accept/${id}`);
      toast.success("Demande acceptée");
      fetchInbox();
    } catch {
      toast.error("Erreur acceptation");
    }
  };

  const reject = async (id) => {
    try {
      await axiosInstance.post(`/exchanges/reject/${id}`);
      toast.success("Demande refusée");
      fetchInbox();
    } catch {
      toast.error("Erreur refus");
    }
  };

  if (loading) return <Layout title="Inbox">Chargement...</Layout>;

  return (
    <Layout title="Demandes d'échange reçues">
      <div className="space-y-4">

        {exchanges.length === 0 && (
          <Card>
            <CardContent className="p-6 text-center text-gray-500">
              Aucune demande d'échange
            </CardContent>
          </Card>
        )}

        {exchanges.map((e) => (
          <Card key={e.id} className="border-amber-200">
            <CardContent className="p-4 space-y-2">
                <div className="font-bold text-amber-900 text-lg">
                    {e.prestation_name}
                </div>

                <div className="text-sm text-gray-600">
                    Demandé par : <strong>{e.requester_name}</strong>
                </div>

                <div className="border rounded-lg p-3 bg-gray-50 space-y-1 text-sm">

                    <div>
                    {/* <strong>Type :</strong> {e.type_soignant} */}
                    <strong>Type :</strong> {e.type_soignant || "—"}
                    </div>

                    <div>
                    <strong>Établissement :</strong> {e.etablissement_name}
                    </div>

                    <div>
                    <strong>Début :</strong>{" "}
                    {e.date_start
                        ? new Date(e.date_start).toLocaleString("fr-BE")
                        : "—"}
                    </div>

                    <div>
                    <strong>Fin :</strong>{" "}
                    {e.date_end
                        ? new Date(e.date_end).toLocaleString("fr-BE")
                        : "—"}
                    </div>

                    <div>
                    <strong>Durée :</strong>{" "}
                    {e.dureeMinutes
                        ? `${Math.floor(e.dureeMinutes / 60)}h${e.dureeMinutes % 60}`
                        : "—"}
                    </div>

                    <div>
                    <strong>Tarif horaire :</strong> {e.base_rate} €
                    </div>

                    <div>
                    <strong>Montant total :</strong> {e.final_rate} €
                    </div>

                    <div>
                    <strong>Statut :</strong>{" "}
                    <span className="font-semibold text-green-600">
                        {e.status}
                    </span>
                    </div>

                </div>

                <div className="flex gap-2 mt-3">
                    <Button
                    onClick={() => accept(e.id)}
                    className="bg-green-600"
                    >
                    Accepter
                    </Button>

                    <Button
                    onClick={() => reject(e.id)}
                    variant="destructive"
                    >
                    Refuser
                    </Button>
                </div>

                </CardContent>     
    </Card>
        ))}
      </div>
    </Layout>
  );
}